const _API: string = import.meta.env.VITE_API_URL;
const _API_F: string = import.meta.env.VITE_FILE_API_URL || _API;

function getApiBaseUrl() {
  return /^https?:\/\//.test(_API) ? _API : location.origin + _API;
}

function getFileApiBaseUrl() {
  return /^https?:\/\//.test(_API_F) ? _API_F : location.origin + _API_F;
}

/** 开发环境 */
export const IS_DEV: boolean = import.meta.env.VITE_IS_DEV === 'true';

/** 自动更新UI缓存提示 */
export const IS_TRACK_UI_TIPS: boolean =
  import.meta.env.VITE_IS_TRACK_UI_TIPS === 'true';

/** 接口地址 */
export const API_BASE_URL: string = getApiBaseUrl();

/** 文件服务接口地址 */
export const FILE_API_BASE_URL: string = getFileApiBaseUrl();

/** 项目名称 */
export const PROJECT_NAME: string = import.meta.env.VITE_APP_NAME;

/** 自动注册VUE组件 */
export const AUTO_VUE_COMPS_REGISTER: 'true' | 'false' = import.meta.env
  .VITE_AUTO_VUE_COMPS_REGISTER;

/** onlyoffice api.js 地址 */
export const ONLYOFFICE_JS_URL = import.meta.env.VITE_ONLYOFFICE_API_JS_URL;

/** 不需要登录的路由 */
export const WHITE_LIST: string[] = [
  '/login',
  '/forget',
  '/login/lzd-dev',
  '/home/tenant-not-found'
];

/** 首页路径, 为空则取第一个菜单的地址 */
export const HOME_PATH: string | undefined = void 0;

/** 外层布局的路由地址 */
export const LAYOUT_PATH = '/';

/** 刷新路由的路由地址 */
export const REDIRECT_PATH = '/redirect';

/** 开启页签栏后是否缓存组件 */
//export const TAB_KEEP_ALIVE = !import.meta.env.DEV;
export const TAB_KEEP_ALIVE = true;

/** token本地缓存的名称 */
export const TOKEN_CACHE_NAME = 'token';

/** 主题配置本地缓存的名称 */
export const THEME_CACHE_NAME = 'theme';

/** i18n本地缓存的名称 */
export const I18N_CACHE_NAME = 'i18n-lang';

/** lzd-modal 弹窗模式本地缓存名称 */
export const LZD_MODAL_TYPE_CACHE_NAME = 'lzd-modal-type';

/** 高德地图key, 请到高德地图官网自行申请 */
export const MAP_KEY = '006d995d433058322319fa797f2876f5';

/** EleAdminPlus授权码 */
export const LICENSE_CODE = import.meta.env.VITE_LICENSE;
